var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"visually-hidden"},[_vm._v("Original paintings by Jessie Tucker")]),_c('ArtShowcase',{attrs:{"artArray":_vm.artArray}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }